import { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Card, CardBody, CardFooter, CardHeader, Col, Container, Row } from 'reactstrap'
// import { blogsDetailData } from '../../common'
import { BenefitsIcon, ConclusionIcon, QuestionMarkFillIcon, QuestionMarkOutlineIcon, RoleOfSolutionArchitectIcon } from '../../common/icons'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { getIPGeoLocation } from '../../common/GeneralUtils'
// core components
import Header from '../../components/header/header'
import Footer from '../../components/footer/footer'
import SoftwareTeamHunt from '../../components/CaseStudy/SoftwareTeamHunt'
import FrequentlyAskedQuestions from '../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'
import ContactBanner from '../../components/banner/ContactBanner'
import OurLatestBlogs from '../../components/OurLatestBlogs/OurLatestBlogs'
// import { HashLink as Link } from 'react-router-hash-link';

// import { BlogDetailsData } from '../../common/BlogDetailsData'
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterShareButton, XIcon } from 'react-share'
import axios from 'axios'
// import BenefitsImg from '../../assets/images/blog/blog-home/blogDetails/New-Project.png'

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const SoftwareTeamHunt = Loadable(
//     lazy(() => import('../../components/CaseStudy/SoftwareTeamHunt'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )
// const ContactBanner = Loadable(
//     lazy(() => import('../../components/banner/ContactBanner'))
// )
// const OurLatestBlogs = Loadable(
//     lazy(() => import('../../components/OurLatestBlogs/OurLatestBlogs'))
// )

const ViewBlogDetailScreen = () => {
    const location = useLocation()
    const [BlogDetailsData, setData] = useState([]);
    const { title } = location.state || {};
    // const shareUrl = `https://varahisoft.com/blog-detail?id=1`
    const shareUrl = window?.location?.href
    const [ContactPageData, setContactPageData] = useState({});
    const [blogsDetailData, setBlogsDetailData] = useState({});

    const getAllContactPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/contactPageData.json');
            setContactPageData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllBlogsDetailData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/blogsDetailData.json');
            setBlogsDetailData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    // console.log('---------shareUrl-->', shareUrl)
    // console.log('---------window?.location-->', window?.location)
    // console.log('---------location-->', location)
    // Parse the URL query parameters
    // const searchParams = new URLSearchParams(location.state?.title)
    // console.log('---searchParams--->', searchParams)
    // const contentId = title // Extracts the id from the URL

    // Define getCountries as an async function
    const getCurrencies = async () => {
        try {
            const res = await axios.get(`/staticDataFiles/data.json`); // Assuming no `values` parameter is required for POST request
            // Set currency state to response data
            return setData(res?.data?.find((content) => content?.bannerData?.title === title))
        } catch (err) {
            console.debug(":Values from get currencies", err);
            // let customMessage = "Currencies load failed";
            // let type = "User Information";
            // let color = "red";
            // ErrorHandle(err, setToasts, customMessage, type, color); // Error handling function
        }
    };

    // useEffect(() => {
    //     fetch('/staticDataFiles/data.json')
    //         .then((response) => {
    //             if (!response.ok) throw new Error('Network response was not ok');
    //             return response.json();
    //         })
    //         .then((jsonData) => setData(jsonData.find((content) => content?.bannerData?.title === title)))
    //         .catch((error) => console.error('Error fetching JSON:', error));
    // }, [title])

    useEffect(() => {
        getCurrencies();
        getIPGeoLocation();
        getAllBlogsDetailData();
        getAllContactPageData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [title])

    const customApp =
        BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication;

    const hasCustomAppContent =
        customApp &&
        (
            customApp.heading ||
            customApp.headingTwo ||
            customApp.paragraph?.length > 0
        );
    const ReadyToBuildYourMobileApp =
        BlogDetailsData?.pageData?.ReadyToBuildYourMobileApp;

    const hasCustomReadyToBuildAppContent =
        ReadyToBuildYourMobileApp &&
        (
            ReadyToBuildYourMobileApp.heading
        );

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper blogs_details">
                <div className="container-fluid">
                    <div className="project-page">
                        <ContactBanner
                            bannerImg={blogsDetailData?.bannerImg}
                            data={BlogDetailsData?.bannerData}
                        />
                        {BlogDetailsData ? <Container className="page-blog-content pb-3">
                            {/* <img src={BlogDetailsData?.bodyImg} className="w-100 img-fluid" alt="img" /> */}
                            <Row className="m-0">
                                <Col lg="8" md="8" sm="8">
                                    <LazyLoadImage
                                        className="w-100 img-fluid"
                                        alt={'blog-img'}
                                        // height={image.height}
                                        src={BlogDetailsData?.headerData?.image} // use normal <img> attributes as props
                                    // width={image.width}
                                    />
                                    <div className="page-top-content">
                                        <h1 className="heading">{BlogDetailsData?.headerData?.title}</h1>
                                        <p className="paragraph">{BlogDetailsData?.headerData?.paragraph}</p>
                                    </div>
                                    {/* introduction */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.introduction?.heading}</h1>
                                        {BlogDetailsData?.pageData?.introduction?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">
                                                {intro?.text}
                                                {intro?.link && (
                                                    <a href={intro?.link} className="ms-1">
                                                        {intro?.label}
                                                    </a>
                                                )}
                                                {intro?.text1}
                                            </p>
                                            // <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                    </div>
                                    {/* Get to know everything about solution architecture */}
                                    {/* <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.aboutSolutionArchitecture?.heading}</h1>
                                        {BlogDetailsData?.pageData?.aboutSolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                            { intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                            </ul>}
                                        )}
                                    </div> */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">
                                            {BlogDetailsData?.pageData?.aboutSolutionArchitecture?.heading}
                                        </h1>

                                        {BlogDetailsData?.pageData?.aboutSolutionArchitecture?.paragraph?.map(
                                            (intro, introIndex) => (
                                                <Fragment key={introIndex}>
                                                    {/* Paragraph text */}
                                                    {intro?.text && (
                                                        <p className="paragraph">{intro.text}</p>
                                                    )}

                                                    {/* Listing Section */}
                                                    {intro?.listing?.length > 0 &&
                                                        intro.listing.map((section, sectionIndex) => (
                                                            <div
                                                                key={sectionIndex}
                                                                className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                            >
                                                                {/* Section Title */}
                                                                {section?.title && (
                                                                    <h4 className="heading m-0">{section.title}</h4>
                                                                )}

                                                                {/* Section List Data */}
                                                                {section?.listData?.map((item, itemIndex) => (
                                                                    <Fragment key={itemIndex}>
                                                                        <p className="paragraph">
                                                                            {item.text}
                                                                            {item.link && (
                                                                                <a href={item.link} className="ms-1">
                                                                                    {item.label}
                                                                                </a>
                                                                            )}
                                                                            {item.text1}
                                                                        </p>

                                                                        {/* Nested bullet list */}
                                                                        {item?.list?.length > 0 && (
                                                                            <ul className="page-custom-made-application-list">
                                                                                {item.list.map((li, liIndex) => (
                                                                                    <li key={liIndex}>
                                                                                        {li?.title && <h6 className='fw-bold'>{li?.title}</h6>}
                                                                                        {li.text}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        )}
                                                                    </Fragment>
                                                                ))}
                                                            </div>
                                                        ))}
                                                </Fragment>
                                            )
                                        )}
                                    </div>

                                    {/* Do you need a custom-made application? */}
                                    {hasCustomAppContent && <Card className='page-custom-made-application-card overflow-hidden'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div p-4'>
                                                {customApp?.heading && <h3 className='m-0'>{customApp?.heading}</h3>}
                                                {customApp?.headingTwo && <h3 className='m-0'>{customApp?.headingTwo}</h3>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4'>
                                                <div className='d-flex gap-3'>
                                                    <div className='mt-2'>
                                                        <QuestionMarkOutlineIcon />
                                                    </div>
                                                    <QuestionMarkFillIcon />
                                                </div>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-13px' }}>
                                                    <QuestionMarkOutlineIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>}
                                    <div className="page-intro-content">
                                        {customApp?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">
                                                    {intro?.text}
                                                    {intro?.link && (
                                                        <a href={intro?.link} className="ms-1">
                                                            {intro?.label}
                                                        </a>
                                                    )}
                                                    {intro?.text1}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div>
                                    <div className="page-intro-content">
                                        {/* Section Title */}
                                        <h1 className="heading">
                                            {BlogDetailsData?.pageData?.["WhatMakesExceptionalUI-UX"]?.title}
                                        </h1>

                                        {BlogDetailsData?.pageData?.["WhatMakesExceptionalUI-UX"]?.listData?.map(
                                            (block, blockIndex) => (
                                                <Fragment key={blockIndex}>
                                                    {/* Intro paragraph */}
                                                    {block?.text && (
                                                        <p className="paragraph">
                                                            {block.text}
                                                            {block.link && (
                                                                <a href={block.link} className="ms-1">
                                                                    {block.label}
                                                                </a>
                                                            )}
                                                            {block.text1}
                                                        </p>
                                                    )}

                                                    {/* Feature list */}
                                                    {block?.list?.length > 0 &&
                                                        block.list.map((item, itemIndex) => (
                                                            <div
                                                                key={itemIndex}
                                                                className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                            >
                                                                <h4 className="heading m-0">{item.title}</h4>
                                                                <p className="paragraph mb-3">{item.text}</p>
                                                            </div>
                                                        ))}
                                                </Fragment>
                                            )
                                        )}
                                    </div>

                                    {/* Solution architecture – the silent hero */}
                                    {/* <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.heading}</h1>
                                        {BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div> */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">
                                            {BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.heading}
                                        </h1>

                                        {BlogDetailsData?.pageData?.solutionArchitectureTheSilentHero?.paragraph?.map(
                                            (intro, introIndex) => (
                                                <Fragment key={introIndex}>
                                                    {/* Paragraph text */}
                                                    {intro?.text && (
                                                        <p className="paragraph">{intro.text}</p>
                                                    )}

                                                    {/* Listing blocks */}
                                                    {intro?.listing?.length > 0 &&
                                                        intro.listing.map((block, blockIndex) => (
                                                            <div
                                                                key={blockIndex}
                                                                className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                            >
                                                                {/* Block title */}
                                                                {block?.title && (
                                                                    <h4 className="heading m-0">{block.title}</h4>
                                                                )}

                                                                {/* Bullet content */}
                                                                {block?.list?.map((item, itemIndex) => (
                                                                    <p key={itemIndex} className="paragraph">
                                                                        {item.text}
                                                                        {item.link && (
                                                                            <a href={item.link} className="ms-1">
                                                                                {item.label}
                                                                            </a>
                                                                        )}
                                                                        {item.text1}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        ))}
                                                </Fragment>
                                            )
                                        )}
                                    </div>

                                    {/* How does Solution Architecture help */}
                                    {/* <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.heading}</h1>
                                        {BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='SolutionArchitectureHelp-step-div'>
                                                    <div className='step-button mb-3' style={{ width: 'fit-content' }}>
                                                        <span>step</span>
                                                        <span>{stepIndex + 1}</span>
                                                    </div>
                                                    <h1 className="heading mb-3">{step?.title}</h1>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                            </Fragment>
                                        )}
                                    </div> */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">
                                            {BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.heading}
                                        </h1>

                                        {BlogDetailsData?.pageData?.howDoesSolutionArchitectureHelp?.paragraph?.map(
                                            (intro, introIndex) => (
                                                <Fragment key={introIndex}>
                                                    {/* Intro text */}
                                                    {intro?.text && (
                                                        <p className="paragraph">{intro.text}</p>
                                                    )}

                                                    {/* Steps */}
                                                    {intro?.steps?.length > 0 &&
                                                        intro.steps.map((step, stepIndex) => (
                                                            <div
                                                                key={stepIndex}
                                                                className="SolutionArchitectureHelp-step-div"
                                                            >
                                                                {/* Step badge */}
                                                                <div
                                                                    className="step-button mb-3"
                                                                    style={{ width: 'fit-content' }}
                                                                >
                                                                    <span>step</span>
                                                                    <span>{stepIndex + 1}</span>
                                                                </div>

                                                                {/* Step title */}
                                                                {step?.title && (
                                                                    <h2 className="heading mb-3">{step.title}</h2>
                                                                )}

                                                                {/* Step description */}
                                                                {step?.paragraph && (
                                                                    <p className="paragraph mb-3">{step.paragraph}</p>
                                                                )}

                                                                {/* Step bullet list */}
                                                                {step?.listing?.length > 0 && (
                                                                    <ul className="page-custom-made-application-list">
                                                                        {step.listing.map((item, itemIndex) => (
                                                                            <li key={itemIndex}>{item.list}</li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        ))}

                                                    {/* Feature list */}
                                                    {intro?.list?.length > 0 && (
                                                        <div className="SolutionArchitectureHelp-step-div">
                                                            {intro.list.map((item, itemIndex) => (
                                                                <div key={itemIndex} className="mb-4">
                                                                    <h6 className="fw-bold mb-2">{item.title}</h6>
                                                                    {item?.paragraph?.map((para, paraIndex) => (
                                                                        <p key={paraIndex} className="paragraph">
                                                                            {para.text}
                                                                        </p>
                                                                    ))}
                                                                    {/* <p className="paragraph">{item.text}</p> */}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Fragment>
                                            )
                                        )}
                                    </div>

                                    {/* What Are the Components of a Solution Architecture */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.whatAreTheComponentsOfASolutionArchitecture?.heading}</h1>
                                        {BlogDetailsData?.pageData?.whatAreTheComponentsOfASolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>

                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <h4 className="heading m-0">{step?.title}</h4>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                                {/* Roadmap list */}
                                                {intro?.list?.length > 0 &&
                                                    intro.list.map((item, itemIndex) => (
                                                        <div
                                                            key={itemIndex}
                                                            className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                        >
                                                            <h6 className="fw-bold m-0">{item.title}</h6>
                                                            <p className="paragraph mb-3">{item.text}</p>
                                                        </div>
                                                    ))}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* Role of Solution Architect */}
                                    {BlogDetailsData?.pageData?.roleOfSolutionArchitect && <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.roleOfSolutionArchitect?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.roleOfSolutionArchitect?.heading}</h2>}
                                                {/* {BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo && <h3 className='m-0'>{BlogDetailsData?.pageData?.doYouNeedCustomMadeApplication?.headingTwo}</h3>} */}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-13px' }}>
                                                    <RoleOfSolutionArchitectIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>}
                                    {/* {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner && <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.heading}</h2>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-13px' }}>
                                                    <RoleOfSolutionArchitectIcon />
                                                </div>
                                            </div>
                                        </div>
                                    </Card>} */}
                                    {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner &&
                                        (BlogDetailsData.pageData.ChoosingTheRightMobilePartner.heading ||
                                            BlogDetailsData.pageData.ChoosingTheRightMobilePartner.heading1) && (
                                            <Card className="page-custom-made-application-card overflow-hidden mt-4">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <div className="custom-made-title-div px-4 py-5 w-100">
                                                        <h2 className="m-0">
                                                            {BlogDetailsData.pageData.ChoosingTheRightMobilePartner.heading}

                                                            {BlogDetailsData.pageData.ChoosingTheRightMobilePartner.label && (
                                                                <a
                                                                    href={
                                                                        BlogDetailsData.pageData.ChoosingTheRightMobilePartner.link ||
                                                                        "#"
                                                                    }
                                                                    className="ms-1"
                                                                >
                                                                    {BlogDetailsData.pageData.ChoosingTheRightMobilePartner.label}
                                                                </a>
                                                            )}

                                                            {BlogDetailsData.pageData.ChoosingTheRightMobilePartner.heading1 && (
                                                                <span className="ms-1">
                                                                    {BlogDetailsData.pageData.ChoosingTheRightMobilePartner.heading1}
                                                                </span>
                                                            )}
                                                        </h2>
                                                    </div>

                                                    <div className="d-flex gap-2 pe-4 justify-content-end w-100">
                                                        <div
                                                            className="d-flex align-items-end"
                                                            style={{ marginBottom: "-13px" }}
                                                        >
                                                            <RoleOfSolutionArchitectIcon />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        )}
                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading && (
                                            <p className="paragraph">{BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.text}
                                                {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.label && (
                                                    <a
                                                        href={
                                                            BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.link ||
                                                            "#"
                                                        }
                                                        className="ms-1"
                                                    >
                                                        {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.label}
                                                    </a>
                                                )}

                                                {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.text1 && (
                                                    <span className="ms-1">
                                                        {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.subHeading?.text1}
                                                    </span>
                                                )}</p>
                                        )}
                                        {BlogDetailsData?.pageData?.ChoosingTheRightMobilePartner?.paragraph?.map(
                                            (para, paraIndex) => (
                                                <Fragment key={paraIndex}>
                                                    {/* Intro text */}
                                                    {para?.text && (
                                                        <p className="paragraph">{para.text}</p>
                                                    )}

                                                    {/* Criteria list */}
                                                    {para?.list?.length > 0 &&
                                                        para.list.map((item, itemIndex) => (
                                                            <div
                                                                key={itemIndex}
                                                                className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                            >
                                                                <h4 className="heading m-0">{item.title}</h4>
                                                                <p className="paragraph mb-3">{item.text}</p>
                                                            </div>
                                                        ))}
                                                </Fragment>
                                            )
                                        )}
                                    </div>

                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.roleOfSolutionArchitect?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <p className="paragraph">{intro?.text}</p>
                                                {intro?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                    {intro?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.listData}</li>)}
                                                </ul>}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* What does a solution architect do? BAITS */}
                                    {/* <div className="page-intro-content">
                                        <h1 className="heading">{BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.heading} <span>{BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.headingTwo}</span></h1>
                                        {BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.paragraph?.map((intro, introIndex) =>
                                            <Fragment key={introIndex}>
                                                <div className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <h4 className="heading m-0">{intro?.title}</h4>
                                                </div>
                                                <p className="paragraph">{intro?.text}</p>

                                                {intro?.steps?.length > 0 && intro?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                                    <p className="paragraph mb-3">{step?.paragraph}</p>
                                                    {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                        {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                                    </ul>}
                                                </div>)}
                                            </Fragment>
                                        )}
                                    </div> */}
                                    <div className="page-intro-content">
                                        <h1 className="heading">
                                            {BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.heading}
                                            {BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.headingTwo && (
                                                <span>
                                                    {" "}
                                                    {BlogDetailsData.pageData.whatDoesASolutionArchitectDoBAITS.headingTwo}
                                                </span>
                                            )}
                                        </h1>

                                        {BlogDetailsData?.pageData?.whatDoesASolutionArchitectDoBAITS?.paragraph?.map(
                                            (intro, introIndex) => (
                                                <Fragment key={introIndex}>
                                                    {/* Section title */}
                                                    {(intro?.title || intro?.label || intro?.title1) && (
                                                        <div className="whatAreTheComponentsOfASolutionArchitecture-step-div">
                                                            <h4 className="heading m-0">
                                                                {intro.title}

                                                                {intro.label && (
                                                                    <a
                                                                        href={intro.link || "#"}
                                                                        className="ms-1"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {intro.label}
                                                                    </a>
                                                                )}

                                                                {intro.title1 && <span> {intro.title1}</span>}
                                                            </h4>
                                                        </div>
                                                    )}

                                                    {/* Paragraph with inline links */}
                                                    {(intro?.text ||
                                                        intro?.label ||
                                                        intro?.text1 ||
                                                        intro?.label1 ||
                                                        intro?.text2) && (
                                                            <p className="paragraph">
                                                                {intro.text}

                                                                {intro.label && (
                                                                    <a
                                                                        href={intro.link || "#"}
                                                                        className="mx-1"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {intro.label}
                                                                    </a>
                                                                )}

                                                                {intro.text1}

                                                                {intro.label1 && (
                                                                    <a
                                                                        href={intro.link1 || "#"}
                                                                        className="mx-1"
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        {intro.label1}
                                                                    </a>
                                                                )}

                                                                {intro.text2}
                                                            </p>
                                                        )}

                                                    {/* Steps (if ever added later) */}
                                                    {intro?.steps?.length > 0 &&
                                                        intro.steps.map((step, stepIndex) => (
                                                            <div
                                                                key={stepIndex}
                                                                className="whatAreTheComponentsOfASolutionArchitecture-step-div"
                                                            >
                                                                <p className="paragraph mb-3">{step.paragraph}</p>

                                                                {step?.listing?.length > 0 && (
                                                                    <ul className="page-custom-made-application-list">
                                                                        {step.listing.map((item, itemIndex) => (
                                                                            <li key={itemIndex}>{item.list}</li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        ))}
                                                </Fragment>
                                            )
                                        )}
                                    </div>


                                    {/* Benefits of a Solution Architecture */}
                                    {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture && (<Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.heading}</h2>}
                                                {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.headingTwo && <h3 className='m-0'>{BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.headingTwo}</h3>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-32px' }}>
                                                    <BenefitsIcon />
                                                    {/* <LazyLoadImage
                                                        className="w-100 img-fluid m-0"
                                                        alt={'image'}
                                                        // height={image.height}
                                                        src={BenefitsImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>)}
                                    {hasCustomReadyToBuildAppContent && (
                                        <Card className="page-custom-made-application-card overflow-hidden mt-4">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="custom-made-title-div px-4 py-5 w-100">
                                                    {BlogDetailsData.pageData.ReadyToBuildYourMobileApp?.heading && (
                                                        <h2 className="m-0">
                                                            {BlogDetailsData.pageData.ReadyToBuildYourMobileApp?.heading}
                                                        </h2>
                                                    )}
                                                </div>
                                                <div className="d-flex gap-2 pe-4 justify-content-end w-100">
                                                    <div className="d-flex align-items-end" style={{ marginBottom: "-32px" }}>
                                                        <BenefitsIcon />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    )}
                                    {/* Paragraph content */}
                                    <div className="page-intro-content">{BlogDetailsData.pageData?.ReadyToBuildYourMobileApp?.paragraph?.map(
                                        (item, index) => (
                                            <p className="paragraph mt-3" key={index}>
                                                {item?.text}

                                                {item?.label && item.link ? (
                                                    <a
                                                        href={item.link || "#"}
                                                        className="mx-1"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {item.label}
                                                    </a>
                                                ) : item.label}

                                                {item?.text1}

                                                {(item?.label1 && item.link1) ? (
                                                    <a
                                                        href={item.link1 || "#"}
                                                        className="mx-1"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {item.label1}
                                                    </a>
                                                ) : item.label1}

                                                {item?.text2}
                                            </p>
                                        )
                                    )}
                                    </div>

                                    <div className="page-intro-content">
                                        {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )}
                                        {BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.steps?.length > 0 && BlogDetailsData?.pageData?.benefitsOfASolutionArchitecture?.steps?.map((step, stepIndex) => <div key={stepIndex} className='whatAreTheComponentsOfASolutionArchitecture-step-div'>
                                            <h4 className="heading m-0">{step?.title}</h4>
                                            <p className="paragraph mb-3">{step?.paragraph}</p>
                                            {step?.listing?.length > 0 && <ul className='page-custom-made-application-list'>
                                                {step?.listing?.map((introList, introListIndex) => <li key={introListIndex}>{introList?.list}</li>)}
                                            </ul>}
                                        </div>)}
                                    </div>

                                    {BlogDetailsData?.pageData?.LookingAhead && (
                                        <div className="page-intro-content">
                                            {/* Heading */}
                                            {BlogDetailsData.pageData.LookingAhead.heading && (
                                                <h1 className="heading">
                                                    {BlogDetailsData.pageData.LookingAhead.heading}
                                                </h1>
                                            )}

                                            {/* Paragraphs */}
                                            {BlogDetailsData.pageData.LookingAhead.paragraph?.map(
                                                (item, index) => (
                                                    <p key={index} className="paragraph">
                                                        {item.text}
                                                    </p>
                                                )
                                            )}
                                        </div>
                                    )}
                                    {BlogDetailsData?.pageData?.AboutVarahiSoft && (
                                        <div className="page-intro-content">
                                            {BlogDetailsData?.pageData?.AboutVarahiSoft.title && (
                                                <h1 className="heading">
                                                    {BlogDetailsData?.pageData?.AboutVarahiSoft.title}
                                                </h1>
                                            )}
                                            {/* About text */}
                                            {BlogDetailsData.pageData.AboutVarahiSoft.paragraph && (
                                                <p className="paragraph">
                                                    {BlogDetailsData.pageData.AboutVarahiSoft?.label && BlogDetailsData.pageData.AboutVarahiSoft.link ? (
                                                        <a
                                                            href={BlogDetailsData.pageData.AboutVarahiSoft.link || "#"}
                                                            className="mx-1"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {BlogDetailsData.pageData.AboutVarahiSoft.label}
                                                        </a>
                                                    ) : BlogDetailsData.pageData.AboutVarahiSoft.label}
                                                    {BlogDetailsData.pageData.AboutVarahiSoft.paragraph}
                                                </p>
                                            )}

                                            {/* Schedule a call CTA */}
                                            {BlogDetailsData.pageData.AboutVarahiSoft.scheduleACall && (
                                                <p className="paragraph fw-semibold">
                                                    <a
                                                        href={BlogDetailsData.pageData.AboutVarahiSoft.scheduleACall.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="me-1"
                                                    >
                                                        {BlogDetailsData.pageData.AboutVarahiSoft.scheduleACall.label}
                                                    </a>
                                                    {BlogDetailsData.pageData.AboutVarahiSoft.scheduleACall.text}
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    {/* Conclusion */}
                                    {BlogDetailsData?.pageData?.conclusion && <Card className='page-custom-made-application-card overflow-hidden mt-4'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <div className='custom-made-title-div px-4 py-5 w-100'>
                                                {BlogDetailsData?.pageData?.conclusion?.heading && <h2 className='m-0'>{BlogDetailsData?.pageData?.conclusion?.heading}</h2>}
                                            </div>
                                            <div className='d-flex gap-2 pe-4 justify-content-end w-100'>
                                                <div className='d-flex align-items-end' style={{ marginBottom: '-0px' }}>
                                                    <ConclusionIcon />
                                                    {/* <LazyLoadImage
                                                        className="w-100 img-fluid m-0"
                                                        alt={'image'}
                                                        // height={image.height}
                                                        src={BenefitsImg} // use normal <img> attributes as props
                                                    // width={image.width}
                                                    /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Card>}
                                    <div className="page-intro-content">
                                        {/* {BlogDetailsData?.pageData?.conclusion?.paragraph?.map((intro, introIndex) =>
                                            <p key={introIndex} className="paragraph">{intro?.text}</p>
                                        )} */}
                                        {/* Related links */}
                                        {BlogDetailsData?.pageData?.conclusion?.paragraph?.map(
                                            (intro, introIndex) => (
                                                <p key={introIndex} className="paragraph">
                                                    {intro.text}

                                                    {intro.label && (
                                                        <a
                                                            href={intro.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="ms-1"
                                                        >
                                                            {intro.label}
                                                        </a>
                                                    )}
                                                </p>
                                            )
                                        )}
                                    </div>
                                </Col>
                                <Col lg="4" md="4" sm="4">
                                    {BlogDetailsData?.socialMediaPost && <Card className="custom_card">
                                        {BlogDetailsData?.socialMediaPost?.pageTitle && <CardHeader>{BlogDetailsData?.socialMediaPost?.pageTitle}</CardHeader>}
                                        <CardBody>
                                            <div className="round-social-icon d-flex no-block gap-2">
                                                <LinkedinShareButton url={shareUrl} title={`Linkedin`}>
                                                    <LinkedinIcon size={32} round />
                                                </LinkedinShareButton>
                                                <FacebookShareButton url={shareUrl} title={`Linkedin`}>
                                                    <FacebookIcon size={32} round />
                                                </FacebookShareButton>
                                                <TwitterShareButton url={shareUrl} title={`Linkedin`}>
                                                    <XIcon size={32} round />
                                                </TwitterShareButton>
                                            </div>
                                        </CardBody>
                                    </Card>}
                                    {BlogDetailsData?.tag && <Card className="custom_card">
                                        {BlogDetailsData?.tag?.pageTitle && <CardHeader>{BlogDetailsData?.tag?.pageTitle}</CardHeader>}
                                        {BlogDetailsData?.tag?.tags?.length > 0 && <CardBody>
                                            {BlogDetailsData?.tag?.tags?.map((tagData, index) => <p key={index} className="tag">{tagData?.title}</p>)}
                                        </CardBody>}
                                    </Card>}
                                    {BlogDetailsData?.aboutAuthor && <Card className="custom_card">
                                        {BlogDetailsData?.aboutAuthor?.pageTitle && <CardHeader>{BlogDetailsData?.aboutAuthor?.pageTitle}</CardHeader>}
                                        <CardBody>
                                            <div className="author-about">
                                                {BlogDetailsData?.aboutAuthor?.authorName && <h1>{BlogDetailsData?.aboutAuthor?.authorName}</h1>}
                                                {BlogDetailsData?.aboutAuthor?.authorContent?.map((content, index) => {
                                                    return (
                                                        <p key={index}>{content?.text}</p>
                                                    )
                                                })
                                                }
                                            </div>
                                        </CardBody>
                                        <CardFooter>Blogs By {BlogDetailsData?.aboutAuthor?.authorName}</CardFooter>
                                    </Card>}
                                </Col>
                            </Row>
                        </Container> : <Container className="page-blog-content pb-3 text-center"><p>No content found for this ID.</p></Container>}
                        <div className="our-latest-blogs position-relative overflow-hidden">
                            <div className="position-absolute" style={{ inset: 0 }}>
                                <div className="acss-lbif7z acss-b61x89"></div>
                            </div>
                            <OurLatestBlogs />
                        </div>
                        <SoftwareTeamHunt data={blogsDetailData?.softwareTeamHunt} />
                        <FrequentlyAskedQuestions
                            faqData={ContactPageData?.FrequentlyAskedQuestionsData}
                        />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

ViewBlogDetailScreen.propTypes = {
    classes: PropTypes.object,
}

export default ViewBlogDetailScreen
